import { render, staticRenderFns } from "./LettresAdd.vue?vue&type=template&id=884310aa&scoped=true"
import script from "./LettresAdd.vue?vue&type=script&lang=js"
export * from "./LettresAdd.vue?vue&type=script&lang=js"
import style0 from "./LettresAdd.vue?vue&type=style&index=0&id=884310aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884310aa",
  null
  
)

export default component.exports